import { type AllTeamsQuery, teamsClient } from '@atlassian/teams-client';

import { type StoreApi } from '../types';

const getAllTeams =
	(allTeamsQuery: AllTeamsQuery, keepExistingData?: boolean) =>
	async ({ getState, setState }: StoreApi) => {
		if (!keepExistingData) {
			setState({
				allTeamsData: {
					teams: [],
					isLoading: true,
					hasError: false,
					cursor: '',
				},
			});
		}

		try {
			const { teams: newTeams, cursor } = await teamsClient.getAllTeams(allTeamsQuery);

			setState({
				allTeamsData: {
					teams: [...getState().allTeamsData.teams, ...newTeams],
					isLoading: false,
					hasError: false,
					cursor,
				},
			});
		} catch (e) {
			setState({
				allTeamsData: {
					isLoading: false,
					hasError: true,
					teams: [],
					cursor: '',
					errorStatusCode: (e as any).status,
				},
			});
		}
	};

export default getAllTeams;
